import { Notify } from "quasar"
import { register } from "register-service-worker"

// The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration

register(import.meta.env.QUASAR_SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter

  // registrationOptions: { scope: './' },

  ready(/* registration */) {
    // console.log('Service worker is active.')
  },

  registered(/* registration */) {
    // console.log('Service worker has been registered.')
  },

  cached(/* registration */) {
    // console.log('Content has been cached for offline use.')
  },

  updatefound(/* registration */) {
    // console.log('New content is downloading.')
  },

  updated() {
    Notify.create({
      message: "App has been updated.",
      color: "accent",
      actions: [
        {
          label: "Refresh",
          color: "white",
          handler: () => {
            location.reload()
          }
        }
      ]
    })
  },

  offline() {
    Notify.create("No internet connection found. App is running in offline mode.")
  },

  error(err) {
    Notify.create(`Offline mode is unavailable: ${err.message}`)
  }
})
